import {
  APPENDIX_URL,
  EXTEND_TERM_ENTRY_URL,
  EXTEND_TERM_SUMMARY_URL,
  REPAYMENT_HOLIDAY_ENTRY_URL,
  REPAYMENT_HOLIDAY_SUMMARY_URL,
} from "App.const";
import { Attestations } from "components/Attestations/Attestations";
import { AssertionAnswers } from "domain/assertions";
import { Menu } from "domain/menuOptions";
import { observer } from "mobx-react";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Store } from "state/store";
import { ATTESTTATION_SCREEN_TITLE } from "./Title.const";

export type AttestationScreenProps = {
  store: Store;
  selectedMenu: Menu;
};

const AttestationScreen = ({ store, selectedMenu }: AttestationScreenProps) => {
  document.title = ATTESTTATION_SCREEN_TITLE;
  const { attestationStore, selectedTreatmentPostStore } = store;
  const [answers, setAnswers] = useState(attestationStore.answers);
  const navigate = useNavigate();

  const [SUMMARY_URL, BACK_URL] = useMemo(() => {
    switch (selectedMenu) {
      case Menu.ExtendTerm:
        return [EXTEND_TERM_SUMMARY_URL, EXTEND_TERM_ENTRY_URL];
      case Menu.RequestRepaymentHoliday:
        return [REPAYMENT_HOLIDAY_SUMMARY_URL, REPAYMENT_HOLIDAY_ENTRY_URL];
      default:
        return [APPENDIX_URL, APPENDIX_URL];
    }
  }, [selectedMenu]);

  const handleSubmit = useCallback(
    async (ans: AssertionAnswers = answers) => {
      const attestationDetails = {
        hardStoppedOnUI: false,
        answers: ans.answers,
      };
      await attestationStore.submitPostAttestations(attestationDetails);
      navigate(SUMMARY_URL, { replace: true });
    },
    [attestationStore, answers, navigate, SUMMARY_URL]
  );

  const handleWrongAnswer = useCallback(
    async (ans: AssertionAnswers = answers) => {
      const wrongAnswerIndex = ans.answers.findIndex(
        (answer) => answer.expected !== answer.answer
      );
      const attestationDetails = {
        hardStoppedOnUI: true,
        answers: ans.answers,
      };
      await attestationStore.submitPostAttestations(attestationDetails);
      await attestationStore.generateError(ans.answers[wrongAnswerIndex].type);
      await selectedTreatmentPostStore.postSelectedTreatments(
        store.selectedTreatmentPayload
      );
      navigate(APPENDIX_URL, { replace: true });
    },
    [
      attestationStore,
      selectedTreatmentPostStore,
      store.selectedTreatmentPayload,
      answers,
      navigate,
    ]
  );

  const handleBack = useCallback(() => {
    navigate(BACK_URL, { replace: true });
  }, [navigate, BACK_URL]);

  return (
    <>
      <Attestations
        questions={answers}
        onChange={setAnswers}
        onBack={handleBack}
        onReady={handleSubmit}
        onWrongAnswer={handleWrongAnswer}
      />
    </>
  );
};

const AttestationScreenObserver = observer(AttestationScreen);

export { AttestationScreenObserver as AttestationScreen };
